import React from 'react';
import { unixFormat } from '../../../../../helpers/times';
import PartnersBaseView from '../../../../Partners/PartnersViews/PartnersBaseView';

import '../../../common-styles/card.scss';
import './style.scss';

const DelayCard = ({episode, $locale, className, cardStyles, pdfSettings}) => {
    return (
        <div
            className={`
                pdf-card
                pdf-card-delay
                ${!!pdfSettings?.delayFontLarge ? 'pdf-card-delay--font-lg' : ''}
                ${className}
            `}
            data-episode={episode.id}
            style={{
                ...cardStyles,
                backgroundColor: !!pdfSettings.delayCardColor ? `#${pdfSettings.delayCardColor}` : '',
            }}
        >
            <div className="pdf-card__content">
                <div className="pdf-card__content-header">
                    {
                        !!pdfSettings?.delayTimeVisible &&
                        <div className={`pdf-card__content-time`}>
                            {unixFormat(episode.timeStart, 'HH:mm')} — {unixFormat(episode.timeStop, 'HH:mm')}
                        </div>
                    }
                </div>
                <div className={`pdf-card__content-title`}>
                    {$locale.getProperty(episode, 'name')}
                </div>
                {
                    !!episode[`info_${$locale.name}`] &&
                    <div className="pdf-card__content-info">
                        {$locale.getProperty(episode, 'info')}
                    </div>
                }
                {
                    (!!episode.partners?.length && !!pdfSettings?.showLogos) &&
                    <div style={{paddingTop: 10}}>
                        <PartnersBaseView
                            partners={episode.partners}
                            size="xs"
                        />
                    </div>
                }
            </div>
        </div>
    )
};

export default DelayCard;
